import React from "react";
import Footer from "../../../components/Footer";

const MiningManufacturing = () => {
  return (
    <section className="bg-white pt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT CONTENT */}
        <div className="px-6 sm:px-10 lg:px-16 py-12 lg:flex lg:items-center">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-3">
              Industries →
            </p>

            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Cyber Security for Mining & Manufacturing
            </h1>

            <p className="font-semibold text-gray-800 mb-6">
              Mining and manufacturing sectors face escalating cyber threats due
              to their reliance on long-lasting, often insecure operational
              technology (OT). Recent ransomware attacks have halted production
              lines, costing millions in downtime and exposing safety-critical
              systems to disruption.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Legacy equipment often predates modern cybersecurity, making it
              vulnerable to exploits that can trigger physical hazards such as
              machinery failures or hazardous material releases.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              The rise of IoT, IIoT, and Industry 4.0 connectivity continues to
              expand attack surfaces, with unpatched devices increasingly
              vulnerable to remote hijacking and operational disruption.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              These industries face unique challenges, including strict safety
              regulations such as OSHA and ISO 45001, supply chain risks from
              third-party vendors, and the need for 24/7 uptime amid ongoing
              skilled workforce shortages.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              How can Synthera help?
            </h3>

            <ul className="space-y-4 mb-8">
              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>OT Asset Visibility & Inventory:</strong> We deploy
                  non-intrusive monitoring to identify every PLC, sensor, and
                  gateway across your environment—including undocumented legacy
                  devices.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Industrial Network Segmentation:</strong> We implement
                  Zero Trust principles across operational environments,
                  ensuring breaches in corporate networks cannot spread to
                  production lines or critical control systems.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Secure Remote Access (SRA):</strong> We replace
                  always-on VPNs with monitored, multi-factor, and just-in-time
                  access so vendors only access the systems they are authorized
                  to maintain.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Safety-First Incident Response:</strong> Our recovery
                  planning includes manual override procedures and offline
                  fail-safes to ensure personnel safety and operational
                  continuity during cyber incidents.
                </p>
              </li>
            </ul>

            <p className="text-gray-700 font-semibold mb-8">
              Our mission is to ensure your digital transformation drives higher
              efficiency—not higher vulnerability—keeping your machines running
              and your people safe.
            </p>

            {/* LINK CTA */}
            <a
              href="/Conntact"
              className="group inline-flex items-center gap-1 font-semibold text-green-700 hover:text-green-800 transition"
            >
              <span className="relative">
                Talk to an expert
                <span className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden lg:block pt-10">
          <img
            src="https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1770613383/Manufacturing_klt1zk.png"
            alt="Mining and Manufacturing Cyber Security"
            className="w-full h-full object-cover"
          />

          {/* GREEN OVERLAY (MATCHED WITH IMAGE OFFSET) */}
          {/* <div className="absolute top-10 left-0 right-0 bottom-0 bg-green-900/70"></div> */}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default MiningManufacturing;
